import { render, staticRenderFns } from "./SingleQuestion.vue?vue&type=template&id=3817c880&scoped=true&"
import script from "./SingleQuestion.vue?vue&type=script&lang=js&"
export * from "./SingleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SingleQuestion.vue?vue&type=style&index=0&id=3817c880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817c880",
  null
  
)

export default component.exports